import {NgModule} from '@angular/core';
import {UiPaginatorComponent} from './ui-paginator/ui-paginator.component';
import {UiPageHeaderComponent} from './ui-page-title/ui-page-header.component';
import {UiModalComponent} from './ui-modal/ui-modal.component';
import {UiChecklistComponent} from './ui-checklist/ui-checklist.component';
import {ModalToggleDirective} from './ui-modal/directives/modal-toggle.directive';
import {UiBasicModule} from '../basic/ui-basic.module';
import {NgOptionComponent, NgSelectComponent} from '@ng-select/ng-select';
import {FormsModule} from '@angular/forms';
import {DeprecatedSharedUtilsModule} from '../../../deprecated-shared-utils-module';
import {UiSwitchManagerComponent} from './ui-switch-manager/ui-switch-manager.component';
import {UiChecklistGroupFieldsComponent} from './ui-checklist/components/ui-checklist-group/ui-checklist-group-fields.component';
import {UiSearch} from './.ui-search/ui-search.component';
import {UiSidebarComponent} from './.ui-sidebar/ui-sidebar.component';
import {UiBreadcrumbComponent} from './.ui-breadcrumb/ui-breadcrumb.component';
import {UiPageComponent} from './.ui-page/ui-page.component';
import {MaterialInputComponent} from '../../../components/material-input/material-input.component';
import {InputComponent} from '../../../input/input.component';
import {NgxMaskDirective} from 'ngx-mask';
import {UploadFilesComponent} from '../../../components/upload-files/upload-files.component';
import { UiChecklistBooleanField } from './ui-checklist/components/ui-checklist-group/components/ui-checklist-boolean-field/ui-checklist-boolean-field';
import { UiChecklistListField } from './ui-checklist/components/ui-checklist-group/components/ui-checklist-list-field/ui-checklist-list-field';
import { UiChecklistSignatureField } from './ui-checklist-signature-field/ui-checklist-signature-field';
import {UiSignaturePadComponent} from './ui-signature-pad/ui-signature-pad';
import {NgTemplateOutlet} from '@angular/common';
import {CpfValidatorDirective} from '../../../directives/cpf-validator.directive';


@NgModule({
    declarations: [
        UiPaginatorComponent,
        UiPageHeaderComponent,
        UiSearch,
        UiModalComponent,
        UiSidebarComponent,
        UiBreadcrumbComponent,
        UiPageComponent,
        ModalToggleDirective,
        UiSwitchManagerComponent,
        UiChecklistGroupFieldsComponent,
        UiChecklistComponent,
        UiChecklistBooleanField,
        UiChecklistListField,
        UiChecklistSignatureField
    ],
    exports: [
        UiPaginatorComponent,
        UiPageHeaderComponent,
        UiSearch,
        UiModalComponent,
        UiSidebarComponent,
        UiBreadcrumbComponent,
        UiPageComponent,
        ModalToggleDirective,
        UiChecklistComponent,
        UiSwitchManagerComponent,
        UiSignaturePadComponent
    ],
    imports: [
        UiBasicModule,
        NgSelectComponent,
        NgOptionComponent,
        FormsModule,
        DeprecatedSharedUtilsModule,
        MaterialInputComponent,
        InputComponent,
        NgxMaskDirective,
        UploadFilesComponent,
        NgTemplateOutlet,
        UiSignaturePadComponent,
        CpfValidatorDirective
    ]
})
export class UiAdvancedModule {
}
